/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Star16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M7.998 11.949l-3.96 2.03a.346.346 0 01-.497-.367l.754-4.287-3.186-3.028a.346.346 0 01.19-.593l4.41-.625L7.69 1.165a.346.346 0 01.617 0l1.98 3.914 4.411.625a.346.346 0 01.19.593l-3.186 3.028.754 4.287a.346.346 0 01-.498.367l-3.96-2.03zm-3.244.54l3.244-1.664 3.245 1.664-.619-3.52 2.594-2.465-3.587-.508L7.998 2.77 6.366 5.996l-3.587.508L5.373 8.97l-.62 3.519z"
        />
    </AccessibleSVG>
);

export default Star16;
